export default __webpack_public_path__ + "static/media/gallery_08.7d5642bd.jpg";